import { IExpiryScale } from 'graphql/types';

export const EXPIRY_SCALES = {
    [IExpiryScale.Days]: 'expiryScale.days',
    [IExpiryScale.Weeks]: 'expiryScale.weeks',
    [IExpiryScale.Months]: 'expiryScale.months',
    [IExpiryScale.Years]: 'expiryScale.years',
};
